import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { ButtonSeverity } from 'primeng/button';

type FeedbackType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
  standalone:false,
})
export class FeedbackDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() type: FeedbackType = 'success';
  @Input() title = '';
  @Input() message = '';
  @Input() confirmLabel = 'Ok';
  @Input() cancelLabel = 'Cancelar';
  @Input() showCancel = false;
  @Input() closable = false;
  @Input() width = '520px';
  @Input() iconSize: number = 36;   
  @Input() iconCircle: number = 72;   

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  get icon(): string {
    switch (this.type) {
      case 'success':
        return 'pi pi-check-circle';
      case 'error':
        return 'pi pi-times-circle';
      case 'warning':
        return 'pi pi-exclamation-triangle';
      default:
        return 'pi pi-info-circle';
    }
  }

  get iconWrapperClass(): string {
    switch (this.type) {
      case 'success':
        return 'bg-green-100 text-green-600';
      case 'error':
        return 'bg-red-100 text-red-600';
      case 'warning':
        return 'bg-yellow-100 text-yellow-600';
      default:
        return 'bg-blue-100 text-blue-600';
    }
  }

  get buttonSeverity(): ButtonSeverity {
    switch (this.type) {
      case 'success':
        return 'success';
      case 'error':
        return 'danger';
      case 'warning':
        return 'warn';
      default:
        return 'info';
    }
  }

  onHide() {
    this.visibleChange.emit(false);
  }

  onConfirmClick() {
    this.confirm.emit();
    this.visibleChange.emit(false);
  }

  onCancelClick() {
    this.cancel.emit();
    this.visibleChange.emit(false);
  }
}
